import { animate, inView, scroll } from 'motion';

const CollectionList = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('collectionList', () => ({
      active: 0,
      desktop: false,
      lis: [],
      height: 0,
      mobile: false,
      init() {
        //const media = window.matchMedia('(min-width: 1024px)');
        //this.mobile = !media.matches;
        //this.lis = this.$root.querySelectorAll('li');
        //const triggerLines = this.$root.querySelectorAll('.trigger-line');
        //const noTriggerLine = this.$root.querySelector('.no-trigger-line');
        //triggerLines.forEach((triggerLine, index) => {
        //  triggerLine.style.height = `${100 / this.lis.length}%`;
        //});
        //noTriggerLine.style.height = `${100 / this.lis.length}%`;
        //this.height = '175dvh';
        //const observerCallback = (entries, observer) => {
        //  entries.forEach((entry) => {
        //    if (this.mobile && entry.isIntersecting) {
        //      this.lis.forEach((li) => {
        //        li.classList.remove('visible');
        //      });
        //      this.active = entry.target.dataset.index;
        //      this.lis[entry.target.dataset.index].classList.add('visible');
        //    }
        //  });
        //};
        //const observer = new IntersectionObserver(observerCallback, {
        //  rootMargin: '-50% 0px -50% 0px',
        //  threshold: 0,
        //});
        //triggerLines.forEach((triggerLine) => {
        //  observer.observe(triggerLine);
        //});
        //window.addEventListener('resize', () => {
        //  const media = window.matchMedia('(min-width: 1024px)');
        //  this.mobile = !media.matches;
        //});
      },
      mouseOver(index) {
        const media = window.matchMedia('(min-width: 1024px)');

        if (media.matches) {
          this.active = index;
        }
      },
    }));
  });
};

export default CollectionList;
